import { getApiErrorMessage, makeToastFaile } from '@/utils/common';

const FORBIDDEN = 403;
const BAD_REQUEST = 400;

// 403 → câu thiếu quyền; 400 → câu BE chủ động soạn (ngày / bộ lọc sai); còn lại (500, mạng)
// → câu chung, không hiện nguyên văn lỗi kỹ thuật của server
export const toastHistoryError = (
  error,
  forbiddenMessage,
  loadFailedMessage,
) => {
  const status = error && error.response && error.response.status;
  if (status === FORBIDDEN) {
    makeToastFaile(forbiddenMessage);
    return;
  }
  if (status === BAD_REQUEST) {
    makeToastFaile(getApiErrorMessage(error, loadFailedMessage));
    return;
  }
  makeToastFaile(loadFailedMessage);
};
